import React from 'react';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';

const Footer = () => {
  return (
    <footer >
      <div style={{ backgroundColor: "#5eba45", width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between", paddingLeft: "50px", height: "5vh" }} >
<div style={{ display: "flex", alignItems: "center" }}>
  <a href="https://www.facebook.com/depotrace" target="_blank" rel="noopener noreferrer" style={{ marginRight: "20px", }} >
    <FacebookIcon style={{ color: "white", fontSize: "16px" }} />
  </a>
  <a href="https://twitter.com/depotrace" target="_blank" rel="noopener noreferrer" style={{ marginRight: "20px" }}>
    <TwitterIcon style={{ color: "white", fontSize: "16px" }} />
  </a>
  <a href="https://Instagram.com/depotrace" target="_blank" rel="noopener noreferrer">
    <InstagramIcon style={{ color: "white", fontSize: "16px" }} />
  </a>
</div>
<a href="/privacypolicy" target="_blank" style={{ color: "white", fontSize: "12px" }}>Privacy Policy</a>
<p style={{ color: "white", fontSize: "12px", textAlign: "left", paddingRight: "50px" }}>© 2025 All rights reserved</p>
</div>
    </footer>
  );
};

export default Footer;
